import OperationLog from './OperationLog'

export default {
  OperationLog
}